import { render, staticRenderFns } from "./VWidget.vue?vue&type=template&id=10f8fc75&"
import script from "./VWidget.vue?vue&type=script&lang=js&"
export * from "./VWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports